import { API_URL } from '../../../app-config/constants';
import { post } from '../request';

export function sendDemoRequest(): Promise<boolean> {
    return post(`${API_URL}/request-a-demo/`);
}
